import isDev from "~/utils/react";

export const loginDefaults = {
  email: import.meta.env.VITE_DEV_EMAIL ?? "",
  password: isDev() ? (import.meta.env.VITE_DEV_PASSWORD ?? "") : "",
};
